import { getCurrentSubdomain } from './io/tenant.js';

// Per-prospect build-time config  -  values injected via VITE_PROSPECT_* env vars
// set on each Vercel project. All fields have defaults so the base deployment
// works without any env vars set.
export const PROSPECT = {
  wordmark:     import.meta.env.VITE_PROSPECT_WORDMARK      ?? 'stackbtc',
  tagline:      import.meta.env.VITE_PROSPECT_TAGLINE       ?? 'Private demo platform. Access by invitation.',
  contactEmail: import.meta.env.VITE_PROSPECT_CONTACT_EMAIL ?? 'contact@stackbtc.net',
  accent:       import.meta.env.VITE_PROSPECT_ACCENT        as string | undefined,
};

// Apply accent override to CSS custom properties at runtime if provided.
if (PROSPECT.accent) {
  const root = document.documentElement;
  root.style.setProperty('--accent', PROSPECT.accent);
  root.style.setProperty('--accent-soft', PROSPECT.accent);
  root.style.setProperty('--gradient-ember-cta', PROSPECT.accent);
}

// Add tenant class to body so CSS can target per-tenant overrides.
const _subdomain = getCurrentSubdomain();
if (_subdomain) {
  document.body.classList.add(`tenant-${_subdomain}`);
}

